<template>
  <v-expansion-panel>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">INFORMAÇÕES FINANCEIRAS</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6">
      <Table
        :view="view"
        @hideBar="$emit('hideBar', $event)"
        @setFinances="setFinances"
        :provider="providerClone"
      ></Table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Table from "./ProvidersBankTable";
import cloneDeep from "lodash/cloneDeep";
export default {
  data: () => ({
    providerClone: []
  }),
  props: {
    view: { type: Boolean, default: false },
    provider: {
      type: Array
    }
  },
  components: {
    Table
  },
  watch: {
    provider(newVal) {
      this.providerClone = cloneDeep(newVal);
    }
  },
  methods: {
    setFinances(item) {
      if (item.index > -1) {
        Object.assign(this.providerClone[item.index], item.data);
      } else {
        this.providerClone.push(item.data);
      }

      this.$emit("setFinances", this.providerClone);
    }
  }
};
</script>

<style></style>
